/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Exercise_Catalogue_TotalInputs */

const en_us2_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} exercises`)
};

const pt_br2_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
};

const es_419_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios`)
};

const pt_pt2_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
};

const fr_fr2_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} exercices`)
};

const de_de2_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Übungen`)
};

const it_it2_exercise_catalogue_total = /** @type {(inputs: Exercise_Catalogue_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} esercizi`)
};

/**
* | output |
* | --- |
* | "{count} exercises" |
*
* @param {Exercise_Catalogue_TotalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_catalogue_total = /** @type {((inputs: Exercise_Catalogue_TotalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Catalogue_TotalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_catalogue_total(inputs)
	if (locale === "es-419") return es_419_exercise_catalogue_total(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_catalogue_total(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_catalogue_total(inputs)
	if (locale === "de-DE") return de_de2_exercise_catalogue_total(inputs)
	if (locale === "it-IT") return it_it2_exercise_catalogue_total(inputs)
	return en_us2_exercise_catalogue_total(inputs)
});
export { exercise_catalogue_total as "exercise.catalogue_total" }